/* Luci Fernández · ficha de producto: galería, zoom y pantalla completa */
(function(){
  if(window.__acGal)return;window.__acGal=true;
  var desk=function(){return window.matchMedia('(min-width:990px)').matches};
  var canHover=window.matchMedia('(hover:hover)').matches;
  function resize(src,w){if(!src)return src;return /[?&]width=\d+/.test(src)?src.replace(/([?&])width=\d+/,'$1width='+w):src+(src.indexOf('?')>-1?'&':'?')+'width='+w}
  function srcOf(img){return img.currentSrc||img.src}

  /* pantalla completa */
  var lb,lbImg,lbCnt,lbList=[],lbI=0;
  function lbRender(){var img=lbList[lbI];if(!img)return;lbImg.src=resize(srcOf(img),1800);lbImg.alt=img.alt||'';lbCnt.textContent=(lbI+1)+' / '+lbList.length}
  function lbGo(d){lbI=(lbI+d+lbList.length)%lbList.length;lbRender()}
  function lbClose(){lb.classList.remove('is-open');document.documentElement.style.overflow=''}
  function lbOpen(list,i){
    if(!lb){
      lb=document.createElement('div');lb.className='ac-lb';lb.setAttribute('role','dialog');lb.setAttribute('aria-modal','true');
      lb.innerHTML='<button type="button" class="ac-lb__x" aria-label="Cerrar">×</button><button type="button" class="ac-lb__nav ac-lb__prev" aria-label="Foto anterior"></button><img class="ac-lb__img" alt=""><button type="button" class="ac-lb__nav ac-lb__next" aria-label="Foto siguiente"></button><div class="ac-lb__cnt"></div>';
      document.body.appendChild(lb);
      lbImg=lb.querySelector('.ac-lb__img');lbCnt=lb.querySelector('.ac-lb__cnt');
      lb.querySelector('.ac-lb__x').addEventListener('click',lbClose);
      lb.querySelector('.ac-lb__prev').addEventListener('click',function(){lbGo(-1)});
      lb.querySelector('.ac-lb__next').addEventListener('click',function(){lbGo(1)});
      lb.addEventListener('click',function(e){if(e.target===lb)lbClose()});
      document.addEventListener('keydown',function(e){if(!lb.classList.contains('is-open'))return;if(e.key==='Escape')lbClose();if(e.key==='ArrowLeft')lbGo(-1);if(e.key==='ArrowRight')lbGo(1)});
      var x0=null;
      lb.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
      lb.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)lbGo(dx<0?1:-1);x0=null});
    }
    lbList=list;lbI=i;lbRender();lb.classList.add('is-open');document.documentElement.style.overflow='hidden';
  }

  function init(root){
    var gal=root.querySelector('.ac-pp__gallery'),main=root.querySelector('[data-main]');
    if(!gal||!main||gal.getAttribute('data-ac-gal'))return;
    gal.setAttribute('data-ac-gal','1');
    var figs=[].slice.call(main.querySelectorAll('.ac-pp__slide'));
    if(!figs.length)return;
    var imgs=figs.map(function(f){return f.querySelector('img')});
    imgs.forEach(function(i){if(i&&i.getAttribute('sizes'))i.sizes='(max-width: 989px) 100vw, 50vw'});
    gal.classList.add('ac-gal');
    var multi=figs.length>1;
    if(multi)gal.classList.add('ac-gal--multi');

    /* la etiqueta de descuento queda fija sobre la galería */
    var flag=main.querySelector('.ac-pp__flag');
    if(flag)main.appendChild(flag);

    var thumbs=[],cnt,cur=0;
    if(multi){
      var th=document.createElement('div');th.className='ac-gal__thumbs';
      figs.forEach(function(f,n){
        var b=document.createElement('button');b.type='button';b.className='ac-gal__th';b.setAttribute('aria-label','Ver foto '+(n+1));
        var im=imgs[n];
        if(im){var t=new Image();t.alt='';t.loading='lazy';t.src=resize(im.getAttribute('src')||srcOf(im),240);b.appendChild(t)}
        b.addEventListener('click',function(){show(n)});
        th.appendChild(b);thumbs.push(b);
      });
      gal.insertBefore(th,gal.firstChild);
      var prev=document.createElement('button');prev.type='button';prev.className='ac-gal__nav ac-gal__prev';prev.setAttribute('aria-label','Foto anterior');
      var next=document.createElement('button');next.type='button';next.className='ac-gal__nav ac-gal__next';next.setAttribute('aria-label','Foto siguiente');
      prev.addEventListener('click',function(e){e.stopPropagation();show((cur-1+figs.length)%figs.length)});
      next.addEventListener('click',function(e){e.stopPropagation();show((cur+1)%figs.length)});
      main.appendChild(prev);main.appendChild(next);
      cnt=document.createElement('div');cnt.className='ac-gal__cnt';main.appendChild(cnt);
    }
    if(canHover){var hint=document.createElement('div');hint.className='ac-gal__hint';hint.textContent='Pasa el ratón para ampliar';main.appendChild(hint)}

    function show(n){
      cur=n;
      figs.forEach(function(f,k){f.classList.toggle('is-on',k===n);f.classList.remove('is-zoom')});
      thumbs.forEach(function(b,k){b.classList.toggle('is-on',k===n)});
      if(thumbs[n]&&desk()){var p=thumbs[n].parentNode;var top=thumbs[n].offsetTop-p.offsetTop;if(top<p.scrollTop||top>p.scrollTop+p.clientHeight-thumbs[n].offsetHeight)p.scrollTo({top:top-10,behavior:'smooth'})}
      if(cnt)cnt.textContent=(n+1)+' / '+figs.length;
      var im=imgs[n],w=im&&(+im.getAttribute('width')||im.naturalWidth),h=im&&(+im.getAttribute('height')||im.naturalHeight);
      if(w&&h)main.style.setProperty('--ac-ratio',(w/h).toFixed(4));
      if(!desk()&&figs[n])main.scrollTo({left:figs[n].offsetLeft,behavior:'smooth'});
    }
    show(0);

    /* zoom al pasar el ratón y clic para pantalla completa */
    figs.forEach(function(f,n){
      if(canHover){
        f.addEventListener('mousemove',function(e){
          if(!desk())return;var r=f.getBoundingClientRect(),im=imgs[n];if(!im)return;
          im.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%';
          f.classList.add('is-zoom');
        });
        f.addEventListener('mouseleave',function(){f.classList.remove('is-zoom')});
      }
      f.addEventListener('click',function(){lbOpen(imgs.filter(Boolean),n)});
    });

    /* al elegir un color, mostrar su foto */
    var data=root.querySelector('[data-variants]'),variants=[];
    try{variants=JSON.parse(data.textContent)}catch(e){}
    root.addEventListener('click',function(e){
      if(!e.target.closest||!e.target.closest('.ac-pp__pill'))return;
      setTimeout(function(){
        var inp=root.querySelector('[data-variant-id]');var id=inp&&inp.value;
        var v=variants.find(function(x){return String(x.id)===String(id)});
        if(!v||!v.featured_media)return;
        var idx=figs.findIndex(function(f){return f.getAttribute('data-media-id')===String(v.featured_media.id)});
        if(idx>-1)show(idx);
      },60);
    });
  }

  function boot(){document.querySelectorAll('[data-ac-pd]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

/* Aparición suave de las secciones al bajar */
(function(){
  if(window.__acReveal||!('IntersectionObserver' in window))return;window.__acReveal=true;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||window.Shopify&&Shopify.designMode)return;
  function run(){
    var els=[].slice.call(document.querySelectorAll('.shopify-section:not([class*="section-group"]) > .ac:not(.ac-pp)'));
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.06});
    els.forEach(function(el){
      if(el.getBoundingClientRect().top<window.innerHeight*.9)return;
      el.classList.add('ac-reveal');io.observe(el);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
